/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Especifica el estado de la reserva, si fue PRERESERVA, COMPLETADA, PARCIAL, CANCELADA
 */
export type EstadoReserva = 'PRE' | 'OK' | 'CANCELADA';

export const EstadoReserva = {
    PRE: 'PRE' as EstadoReserva,
    OK: 'OK' as EstadoReserva,
    CANCELADA: 'CANCELADA' as EstadoReserva
};

